import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import ImageUpload from '../components/ui/ImageUpload';
import { useAdminData } from '../contexts/AdminDataContext';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { RadioGroup } from '../components/ui/RadioGroup';
import { Toggle } from '../components/ui/Toggle';
import { Button } from '../components/ui/Button';
import { ArrowLeft, Sparkles, ChevronDown, ChevronUp, RefreshCw } from 'lucide-react';
const RewardCreate = () => {
  const navigate = useNavigate();
  const {
    createReward,
    showToast
  } = useAdminData();
  const [isLoading, setIsLoading] = useState(false);
  const [expandedProposal, setExpandedProposal] = useState<number | null>(null);
  // Form State
  const [formData, setFormData] = useState({
    type: 'multi-use',
    name: '',
    description: '',
    terms: '',
    cost: '',
    limitType: 'unlimited',
    limitQuantity: '',
    limitPerUser: false,
    startDate: '',
    endDate: '',
    locations: [] as string[],
    code: '',
    maxUses: '',
    image: '',
    partner: 'La Saponaria',
    partnerId: 'PTR-001',
    rewardType: 'Prodotto',
    location: 'Tutte le Sedi'
  });
  const aiProposals = [{
    id: 1,
    name: 'Set Attivi Puri (Fitoretinolo + Collagene Vegetale)',
    type: 'Prodotto Viso',
    cost: '60-70 punti',
    description: 'Duo di attivi concentrati anti-age: Fitoretinolo e Collagene Vegetale per skincare personalizzata',
    why: 'Trend prodotti anti-age naturali +22%. Attivi puri hanno 35% più riscatti nella fascia 60-75 punti. Alta domanda da segmento 35-50 anni.'
  }, {
    id: 2,
    name: 'Kit Cosmetici Solidi Completo',
    type: 'Cosmetici Solidi',
    cost: '45-55 punti',
    description: 'Shampo solido + Balsamo solido + Bagnoschiuma solido. Zero waste, plastic-free, 100% naturale',
    why: 'Cosmetici solidi zero-waste +25% nel periodo. Prodotti eco-friendly hanno retention 30% più alta. Perfetto per utenti attenti alla sostenibilità.'
  }];
  const handleInputChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleInsertProposal = (proposal: (typeof aiProposals)[0]) => {
    setFormData(prev => ({
      ...prev,
      name: proposal.name,
      description: proposal.description,
      cost: proposal.cost.split('-')[0].replace(' 💎', '').trim(),
      rewardType: proposal.type
    }));
    showToast('Campi aggiornati con suggerimento AI');
  };
  const handleGenerateVariant = () => {
    showToast('Nuova variante generata');
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Create reward object
    const newReward = {
      partnerId: formData.partnerId,
      code: formData.code || `RWD-${Date.now()}`,
      name: formData.name,
      partner: formData.partner,
      type: formData.rewardType,
      status: 'Attivo' as const,
      cost: parseInt(formData.cost) || 0,
      image: formData.image || 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=200&h=200&fit=crop',
      availability: {
        current: formData.limitType === 'unlimited' ? 0 : parseInt(formData.limitQuantity) || 0,
        total: formData.limitType === 'unlimited' ? 0 : parseInt(formData.limitQuantity) || 0,
        unlimited: formData.limitType === 'unlimited'
      },
      redemptionsPeriod: 0,
      redemptionsTotal: 0,
      lastRedemption: 'Mai',
      location: formData.location,
      startDate: formData.startDate || null,
      endDate: formData.endDate || null
    };
    setTimeout(() => {
      createReward(newReward);
      setIsLoading(false);
      navigate('/rewards');
    }, 1000);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-3762">
      <div className="w-20 flex-shrink-0" data-id="element-3763">
        <Sidebar data-id="element-3764" />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3765">
        <Topbar data-id="element-3766" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3767">
          <div className="mb-6" data-id="element-3768">
            <button onClick={() => navigate('/rewards')} className="flex items-center text-sm text-gray-500 hover:text-gray-900 mb-4" data-id="element-3769">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-3770" />
              Torna ai premi
            </button>
            <PageHeader title="Crea premio" subtitle="Configura un'offerta riscattabile con diamond." data-id="element-3771" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3772">
            {/* Main Form - 2 columns */}
            <div className="lg:col-span-2" data-id="element-3773">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3774">
                {/* 1. Tipo Premio */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3775">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3776">
                    Tipo di Premio
                  </h3>
                  <RadioGroup name="type" value={formData.type} onChange={val => handleInputChange('type', val)} options={[{
                  value: 'multi-use',
                  label: 'Codice sconto multi-uso',
                  description: 'Un unico codice utilizzabile da più utenti (es. SUMMER2025)'
                }, {
                  value: 'one-time',
                  label: 'Offerta one-time',
                  description: 'Codici univoci, ognuno valido una sola volta'
                }, {
                  value: 'other',
                  label: 'Altro',
                  description: 'Premi fisici, eventi o altre tipologie senza codice'
                }]} helperText="Scegli il metodo di riscatto più adatto." data-id="element-3777" />
                </div>

                {/* 2. Dettagli */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3778">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3779">
                    Dettagli
                  </h3>
                  <div className="space-y-4" data-id="element-3780">
                    <Input label="Nome premio" placeholder="Es. Buono Amazon €50" value={formData.name} onChange={e => handleInputChange('name', e.target.value)} required data-id="element-3781" />

                    <div data-id="element-3782">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3783">
                        Partner
                      </label>
                      <select value={formData.partner} onChange={e => {
                      handleInputChange('partner', e.target.value);
                      // Map partner to partnerId
                      const partnerMap: Record<string, string> = {
                        'La Saponaria': 'PTR-001',
                        NaturaSì: 'PTR-002',
                        BioSapori: 'PTR-003'
                      };
                      handleInputChange('partnerId', partnerMap[e.target.value] || 'PTR-001');
                    }} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-3784">
                        <option value="La Saponaria" data-id="element-3785">La Saponaria</option>
                        <option value="NaturaSì" data-id="element-3786">NaturaSì</option>
                        <option value="BioSapori" data-id="element-3787">BioSapori</option>
                      </select>
                    </div>

                    <Input label="Tipo premio" placeholder="Es. Prodotto Viso, Buono Sconto, Workshop" value={formData.rewardType} onChange={e => handleInputChange('rewardType', e.target.value)} data-id="element-3788" />

                    <Textarea label="Descrizione breve" placeholder="Descrivi cosa riceverà l'utente..." value={formData.description} onChange={e => handleInputChange('description', e.target.value)} rows={3} data-id="element-3789" />
                    <Textarea label="Termini e Condizioni" placeholder="Inserisci eventuali limitazioni o istruzioni per l'uso..." value={formData.terms} onChange={e => handleInputChange('terms', e.target.value)} rows={3} data-id="element-3790" />

                    <ImageUpload label="Immagine premio" currentImage={formData.image} onImageChange={url => handleInputChange('image', url)} helperText="Carica un'immagine rappresentativa del premio" data-id="element-3791" />
                  </div>
                </div>

                {/* 3. Diamond e Limiti */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3792">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3793">
                    Diamond e Limiti
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3794">
                    <Input label="Costo in Diamond" type="number" placeholder="0" value={formData.cost} onChange={e => handleInputChange('cost', e.target.value)} required min="0" data-id="element-3795" />
                    <div data-id="element-3796">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3797">
                        Disponibilità
                      </label>
                      <div className="flex gap-4 mb-3" data-id="element-3798">
                        <label className="flex items-center" data-id="element-3799">
                          <input type="radio" name="limitType" value="unlimited" checked={formData.limitType === 'unlimited'} onChange={() => handleInputChange('limitType', 'unlimited')} className="text-green-600 focus:ring-green-600" data-id="element-3800" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-3801">
                            Illimitata
                          </span>
                        </label>
                        <label className="flex items-center" data-id="element-3802">
                          <input type="radio" name="limitType" value="limited" checked={formData.limitType === 'limited'} onChange={() => handleInputChange('limitType', 'limited')} className="text-green-600 focus:ring-green-600" data-id="element-3803" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-3804">
                            Limitata
                          </span>
                        </label>
                      </div>
                      {formData.limitType === 'limited' && <Input type="number" placeholder="Quantità totale" value={formData.limitQuantity} onChange={e => handleInputChange('limitQuantity', e.target.value)} min="1" data-id="element-3805" />}
                    </div>
                  </div>
                  <div className="pt-4 border-t border-gray-100" data-id="element-3806">
                    <Toggle label="Limite per utente" description="Consenti un solo riscatto per utente" checked={formData.limitPerUser} onChange={val => handleInputChange('limitPerUser', val)} data-id="element-3807" />
                  </div>
                </div>

                {/* 4. Validità e Sedi */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3808">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3809">
                    Validità e Sedi
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3810">
                    <Input label="Data inizio (opzionale)" type="date" value={formData.startDate} onChange={e => handleInputChange('startDate', e.target.value)} data-id="element-3811" />
                    <Input label="Data fine (opzionale)" type="date" value={formData.endDate} onChange={e => handleInputChange('endDate', e.target.value)} data-id="element-3812" />
                  </div>
                  <div data-id="element-3813">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3814">
                      Sede applicabile
                    </label>
                    <input type="text" placeholder="Es. Milano Centro, Tutte le Sedi" value={formData.location} onChange={e => handleInputChange('location', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-3815" />
                  </div>
                </div>

                {/* Sezione Codici (Condizionale) */}
                {formData.type === 'multi-use' && <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3816">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3817">
                      Configurazione Codice
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3818">
                      <Input label="Codice promozionale" placeholder="Es. SUMMER2025" value={formData.code} onChange={e => handleInputChange('code', e.target.value)} data-id="element-3819" />
                      <Input label="Numero massimo utilizzi (opzionale)" type="number" placeholder="Illimitato" value={formData.maxUses} onChange={e => handleInputChange('maxUses', e.target.value)} data-id="element-3820" />
                    </div>
                  </div>}

                {/* Actions */}
                <div className="flex items-center justify-end gap-3 pt-4 pb-10" data-id="element-3821">
                  <Button type="button" variant="ghost" onClick={() => navigate('/rewards')} data-id="element-3822">
                    Annulla
                  </Button>
                  <Button type="submit" variant="primary" isLoading={isLoading} data-id="element-3823">
                    Pubblica premio
                  </Button>
                </div>
              </form>
            </div>

            {/* AI Assistant Sidebar - 1 column */}
            <div className="lg:col-span-1" data-id="element-3824">
              <div className="sticky top-6 space-y-4" data-id="element-3825">
                <div className="rounded-lg p-5 shadow-sm" style={{
                background: 'linear-gradient(135deg, rgba(255, 0, 77, 0.05) 0%, rgba(116, 10, 214, 0.05) 100%)',
                borderLeft: '4px solid',
                borderImage: 'linear-gradient(180deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%) 1'
              }} data-id="element-3826">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3827">
                    <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full" style={{
                    background: 'linear-gradient(90deg, rgba(255, 0, 77, 0.1) 0%, rgba(116, 10, 214, 0.1) 100%)'
                  }} data-id="element-3828">
                      <Sparkles className="h-4 w-4" style={{
                      color: '#740AD6'
                    }} data-id="element-3829" />
                      <span className="text-xs font-semibold" style={{
                      color: '#740AD6'
                    }} data-id="element-3830">
                        AI
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-gray-900" data-id="element-3831">
                      Assistente Offerte
                    </h3>
                  </div>

                  <div className="space-y-3 mb-4" data-id="element-3832">
                    {aiProposals.map(proposal => <div key={proposal.id} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-3833">
                        <div className="mb-3" data-id="element-3834">
                          <h4 className="font-medium text-gray-900 mb-1" data-id="element-3835">
                            {proposal.name}
                          </h4>
                          <div className="flex items-center gap-2 text-xs mb-2" data-id="element-3836">
                            <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full" data-id="element-3837">
                              {proposal.type}
                            </span>
                            <span className="text-gray-600" data-id="element-3838">
                              {proposal.cost}
                            </span>
                          </div>
                          <p className="text-sm text-gray-600" data-id="element-3839">
                            {proposal.description}
                          </p>
                        </div>

                        <button onClick={() => setExpandedProposal(expandedProposal === proposal.id ? null : proposal.id)} className="flex items-center gap-1 text-xs transition-colors mb-2" style={{
                      color: '#740AD6'
                    }} data-id="element-3840">
                          Perché questo?
                          {expandedProposal === proposal.id ? <ChevronUp className="h-3 w-3" data-id="element-3841" /> : <ChevronDown className="h-3 w-3" data-id="element-3842" />}
                        </button>

                        {expandedProposal === proposal.id && <div className="mb-3 p-3 bg-gray-50 rounded text-xs text-gray-600 border-t border-gray-200" data-id="element-3843">
                            {proposal.why}
                          </div>}

                        <div className="flex gap-2" data-id="element-3844">
                          <button type="button" onClick={() => handleInsertProposal(proposal)} className="flex-1 text-xs font-medium py-2 px-3 border transition-colors" style={{
                        color: '#740AD6',
                        borderColor: '#740AD6',
                        borderRadius: '100px'
                      }} data-id="element-3845">
                            Inserisci nel form
                          </button>
                          <button type="button" onClick={handleGenerateVariant} className="p-2 text-gray-500 hover:text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" title="Genera variante" data-id="element-3846">
                            <RefreshCw className="h-4 w-4" data-id="element-3847" />
                          </button>
                        </div>
                      </div>)}
                  </div>

                  <p className="text-xs text-gray-400 pt-4 border-t border-gray-200" data-id="element-3848">
                    Basato su dati aggregati. Nessun dato personale.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default RewardCreate;